// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__am-Xb","footer":"ModalInfo_footer__2R52y"};